import { h } from '@stencil/core';

export const TooltipArrow = () => (
  <svg width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.93934 0.49009C5.52513 -0.163364 6.47487 -0.163363 7.06066 0.49009L12 6L0 6L4.93934 0.49009Z" fill="white" />
  </svg>
);
